import type { ButtonHTMLAttributes } from 'react';
import React from 'react';
import type { AllIconType } from '../../util/types';
import type { ButtonProps } from './types';
import { ButtonIconStyled } from './Button.styled';
import { getIconComponent } from '../../util/reactFunc';
import { BUTTON_ICON_WRAPPER } from '../../util/data-id';

type Ref = HTMLButtonElement;
type HTMLProps = Omit<ButtonHTMLAttributes<Ref>, 'color'>;
interface Props extends ButtonProps, HTMLProps {
  /**
   * Sets icon inside button.
   */
  icon: AllIconType;
  /**
   * Shapes button as a circle.
   */
  isCircle?: boolean;

  asLink?: boolean;
  /**
   * Turns padding on/off
   */
  hasPadding?: boolean;
}

const ButtonIcon = React.forwardRef<Ref, Props>(({
  icon,
  color = 'primary',
  size = 'md',
  asLink = false,
  isOutline = false,
  isCircle = false,
  toggle = null,
  highlight = false,
  hideShadow = false,
  hasPadding = true,
  ...other
}: Props, ref) => (
  <ButtonIconStyled
    ref={ref}
    data-id={BUTTON_ICON_WRAPPER}
    aria-pressed={toggle as boolean}
    $color={color}
    $highlight={highlight}
    $size={size}
    $isOutline={isOutline}
    $isCircle={isCircle}
    $hideShadow={hideShadow}
    $asLink={asLink}
    $hasPadding={hasPadding}
    {...other as HTMLProps}
  >
    {getIconComponent(icon, size)}
  </ButtonIconStyled>
));

ButtonIcon.displayName = 'ButtonIcon';

export default ButtonIcon;
